export default __webpack_public_path__ + "static/social-6b9178ec84584112850745ee13fbb66c.png";